import { useTranslation } from 'react-i18next';

export default function HeroBanner() {
  const { t } = useTranslation('home');

  const guarantees = [
    { icon: 'ri-shield-check-line', title: t('guaranteePhysicalGold') },
    { icon: 'ri-government-line', title: t('guaranteeAuthority') },
    { icon: 'ri-eye-line', title: t('guaranteeTransparency') },
  ];

  return (
    <div className="relative overflow-hidden">
      {/* 全幅背景图 - 金丝绸缎 + 金条 */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Luxurious%20golden%20silk%20fabric%20background%20with%20elegant%20draping%20folds%2C%20warm%20champagne%20and%20gold%20tones%2C%20soft%20studio%20lighting%2C%20premium%20luxury%20texture%2C%20abstract%20elegant%20background%20with%20subtle%20shimmer%2C%20high-end%20product%20photography%20backdrop%2C%20warm%20beige%20and%20amber%20color%20palette%2C%20smooth%20satin%20material%20with%20gentle%20highlights%2C%20no%20objects&width=800&height=500&seq=hero-silk-gold-v3&orientation=landscape"
          alt="gold silk background"
          className="w-full h-full object-cover object-center"
        />
        {/* 左侧轻微遮罩保证文字可读 */}
        <div className="absolute inset-0 bg-gradient-to-r from-gold-50/80 via-gold-50/40 to-transparent" />
      </div>

      {/* 内容区 */}
      <div className="relative px-5 pt-3 pb-6">
        {/* 主标题 - 两行 */}
        <h1 className="text-brown-900 text-[22px] font-bold leading-snug mb-4">
          <span className="block">{t('heroTitleLine1')}</span>
          <span className="block mt-0.5">{t('heroTitleLine2')}</span>
        </h1>

        {/* 三个保障标签 - 横向排列带竖线分隔 */}
        <div className="flex items-center gap-3">
          {guarantees.map((g, index) => (
            <div key={g.title} className="flex items-center gap-3">
              <div className="flex items-center gap-1">
                <span className="w-4 h-4 flex items-center justify-center text-gold-500">
                  <i className={`${g.icon} text-sm`}></i>
                </span>
                <span className="text-brown-700 text-xs font-medium">
                  {g.title}
                </span>
              </div>
              {index < guarantees.length - 1 && (
                <span className="w-px h-3 bg-brown-300/50" />
              )}
            </div>
          ))}
        </div>

        {/* 右下角100%徽章 */}
        <div className="absolute bottom-3 right-5">
          <div className="w-[72px] h-[72px] rounded-full border-2 border-gold-400/60 bg-gradient-to-br from-gold-100/90 to-gold-200/90 backdrop-blur-sm flex flex-col items-center justify-center shadow-md">
            <span className="text-brown-800 text-[9px] font-medium leading-none">
              {t('physicalGuaranteeBadge')}
            </span>
            <span className="text-brown-900 text-lg font-bold leading-none mt-0.5">
              100%
            </span>
            <span className="text-brown-600 text-[8px] leading-none mt-0.5">
              {t('realGold')}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}